/**
 * 区分pc和移动端
 * 在index.html中加入两个div，id分别是pc跟mobile，在home.vue文件中通过media query控制两个div的展示
 * @param media
 */
function check(media) {
  const mediaEl = document.getElementById(media);
  return mediaEl && window.getComputedStyle(mediaEl).display !== 'none';
}

export function checkIsPc() {
  return check('pc');
}

export function checkIsMobile() {
  return check('mobile');
}

export function updateDevice() {
  device.isPc = checkIsPc();
  device.isMobile = checkIsMobile();
}

export const device = {
  isPc: checkIsPc(),
  isMobile: checkIsMobile(),
};
